module.exports = __webpack_public_path__ + "images/mdj/members/message/inboxdetail/inboxdetail_btn01-1d38bc968e784c8cf4b5bc0815fa03ab.jpg";